// Function to extract only numbers from input
export const extractNumbers = (value: string): string => {
  // Extract only digits from the string
  return value.replace(/\D/g, '');
};
